<template>
    <div v-bind:class="[ 'select-col', 'component-' + box.component]">
        <div v-bind:class="[ 'mobile-fabric-preview', (currentData.ref_number !== 'none') ? 'show-border' : '']">
            <button v-if="currentData.ref_number !== 'none'" type="button" class="zoom-btn"
                    v-bind:data-refnr="currentData.ref_number"
                    v-bind:data-title="currentData.name" v-bind:data-infotext='currentData.infotext'
                    v-bind:data-price='currentData.price' v-bind:data-weave="currentData.weave"
                    v-bind:data-yarn="currentData.yarn"
                    v-bind:data-weight="currentData.weight" v-bind:data-composition="currentData.composition" v-bind:data-zoom="currentData.zoom"
                    @click="zoomFabric" title="{{ translations['Further informations'] }}">Details
            </button>
        </div>
        <div class="top-step-name basic-border basic-color">{{ box.title }}<span v-if="box.extra" class="extra_price"> + {{ box.extra }} €</span>
        </div>
        <div class="designer-detailbox-description">
            <p><span id="detail-description">{{{ box.todo }}}</span></p>
        </div>
        <!-- FILTERBOXES -->
        <filter :filtercolor="filtercolor" :filterpattern="filterpattern" :filterweave="filterweave"
                :filtermaterial="filtermaterial"
                :filteroccasion="filteroccasion" :range1="range1" :range2="range2" :boolfilter="boolfilter"
                :filtername="filtername"></filter>
        <!-- FABRICS -->
        <fabrics :baseurl="baseurl" :box="box" :fabrics="fabrics" :filtercolor="filtercolor"
                 :filterpattern="filterpattern" :filterweave="filterweave" :filtermaterial="filtermaterial"
                 :filteroccasion="filteroccasion" :range1="range1"
                 :range2="range2" :boolfilter="boolfilter" :fields="fields" :filtername="filtername"
                 :personal="personal" :muster1="muster1" :muster2="muster2" :muster3="muster3"
                 :muster4="muster4" :showpattern="showPattern" :showcolor="showColor" :showweave="showWeave"
                 :showmaterial="showMaterial" :showoccasion="showOccasion" :showprice="showPrice"
                 :showname="showName"></fabrics>
        <!-- MODAL -->
        <div v-if="currentData.ref_number !== 'none'" class="preview mobile-fabric-zoom-preview">
            <img v-if="currentData.zoom" v-bind:src="this.baseurl + 'media/'+ currentData.zoom+''" title=""
                 alt="">
        </div>
    </div>
    <zoom v-if="zoom" :zoom="zoom" :show.sync="show" :globals="globals" :muster1="muster1" :muster2="muster2"
          :muster3="muster3" :muster4="muster4"></zoom>
</template>

<script>
var jQuery = require('jquery')

import Filter from '../partials/Filter.vue'
import Fabrics from '../partials/Fabrics.vue'
import Zoom from '../partials/Zoom.vue'

export default {
  name: 'Fabric',
  data: function () {
    return {
      fabricsLimit: 30,
      showPattern: false,
      showColor: false,
      showWeave: false,
      showMaterial: false,
      showOccasion: false,
      showPrice: false,
      showName: false,
      showSeason: false,
      selectPrice: '49.90',
      filtercolor: '',
      filterpattern: '',
      filterweave: '',
      filtermaterial: '',
      filteroccasion: '',
      filtername: '',
      fields: [ 'name', 'color', 'weave', 'season', 'occasion', 'pattern', 'material' ],
      boolfilter: { 'topseller': '0', 'new': '0' },
      range1: { value: 49, min: 49, max: 100 },
      range2: { value: 100, min: 50, max: 100 },
      currentData: {},
      globals: window.shirtdesigner,
      translations: window.shirtdesigner.translations,
      scrolling: false
    }
  },
  components: {
    Filter,
    Fabrics,
    Zoom
  },
  props: {
    'baseurl': String,
    'personal': Object,
    'fabrics': Array,
    'zoom': Object,
    'filtercolor': String,
    'filterpattern': String,
    'filterweave': String,
    'filtermaterial': String,
    'filteroccasion': String,
    'filtername': String,
    'muster1': String,
    'muster2': String,
    'muster3': String,
    'muster4': String,
    show: {
      type: Boolean,
      required: true,
      twoWay: true
    }
  },
  events: {
    setFilter: function (event, callback) {
      switch (event.currentTarget.dataset.select) {
        case 'color':
          if (event.currentTarget.id === 'all') {
            this.filtercolor = ''
            this.showColor = false
            callback('Color')
          } else {
            this.filtercolor = event.currentTarget.id
            callback(this.filtercolor)
          }
          break
        case 'pattern':
          if (event.currentTarget.id === 'all') {
            this.filterpattern = ''
            this.showPattern = false
            callback('Pattern')
          } else {
            this.filterpattern = event.currentTarget.id
            callback(this.filterpattern)
          }
          break
        case 'weave':
          if (event.currentTarget.id === 'all') {
            this.filterweave = ''
            this.showWeave = false
            callback('Weave')
          } else {
            this.filterweave = event.currentTarget.id
            callback(this.filterweave)
          }
          break
        case 'material':
          if (event.currentTarget.id === 'all') {
            this.filtermaterial = ''
            this.showMaterial = false
            callback('Material')
          } else {
            this.filtermaterial = event.currentTarget.id
            callback(this.filtermaterial)
          }
          break
        case 'occasion':
          if (event.currentTarget.id === 'all') {
            this.filteroccasion = ''
            this.showOccasion = false
            callback('Occasion')
          } else {
            this.filteroccasion = event.currentTarget.id
            callback(this.filteroccasion)
          }
          break
        case 'name':
          this.filtername = event.currentTarget.value
          callback(this.filtername)
          break
      }
    },
    checkDesign: function (event) {
      this.$dispatch('mainCheckDesign', event, function () {})
    },
    setBoolFilter: function (event, callback) {
      if (this.boolfilter[event.currentTarget.id] !== '1') {
        this.boolfilter[event.currentTarget.id] = '1'
        callback('1')
      } else {
        this.boolfilter[event.currentTarget.id] = '0'
        callback('0')
      }
    },
    resetFilter: function () {
      this.showPattern = false
      this.showColor = false
      this.showWeave = false
      this.showMaterial = false
      this.showOccasion = false
      this.showSeason = false
      this.showPrice = false
      this.showName = false
      this.range1.value = this.range1.min
      this.range2.value = this.range2.max
      this.resetBoolFilter()
      this.filtercolor = ''
      this.filterpattern = ''
      this.filterweave = ''
      this.filtermaterial = ''
      this.filteroccasion = ''
      this.filtername = ''
    },
    updatePersonal: function (event) {
      window.shirtdesigner.extraPrices['fabric'] = Number(event.currentTarget.dataset.price).toFixed(2)
      this.$dispatch('updatePersonalData', [event.currentTarget.dataset.component, event.currentTarget.id])
      this.$dispatch('updatePersonalData', ['fabric_quality', event.currentTarget.dataset.fabric_quality])
      this.setCurrentData(event.currentTarget.id)
    }
  },
  methods: {
    selectFabric: function (event) {
      this.$dispatch('getFabricData', event)
    },
    showFilter: function (event) {
      this.resetFilter()
      var t = event.currentTarget.id.substr(0, event.currentTarget.id.indexOf('Button'))
      var f = 'show' + t.charAt(0).toUpperCase() + t.substr(1)
      this[f] = 'true'
    },
    thumbUrl: function (event) {
      return this.baseurl + event.currentTarget.dataset.thumb
    },
    resetBoolFilter: function () {
      var b
      for (b in this.boolfilter) {
        this.boolfilter[b] = '0'
      }
    },
    setCurrentData: function (sku) {
      this.currentData = jQuery.grep(this.fabrics, function (e) { return e.ref_number === sku })[0]
    },
    zoomFabric: function (event) {
      this.zoom = {
        img: this.baseurl + 'media/' + event.currentTarget.dataset.zoom,
        title: event.currentTarget.dataset.title,
        infotext: event.currentTarget.dataset.infotext,
        weight: event.currentTarget.dataset.weight,
        composition: event.currentTarget.dataset.composition,
        weave: event.currentTarget.dataset.weave,
        yarn: event.currentTarget.dataset.yarn,
        refnr: event.currentTarget.dataset.refnr,
        price: Number(event.currentTarget.dataset.price).toFixed(2)
      }
      this.show = true
    },
    addMobileSample: function (event) {
      /*global localStorage: false */
      var exists = false
      var message = ''
      var free = ''
      var keys = ['muster1', 'muster2', 'muster3', 'muster4']
      var i = 0
      var key
      while (keys[i]) {
        key = keys[i]
        if (localStorage.getItem(key)) {
          if (event.currentTarget.dataset.refnr === JSON.parse(localStorage.getItem(key))) {
            exists = key
            break
          }
        } else {
          if (!free) free = key
        }
        i++
      }
      if (!exists && free) {
        localStorage.setItem(free, JSON.stringify(event.currentTarget.dataset.refnr))
        this.$dispatch('setSwatch', {key: free, value: event.currentTarget.dataset.refnr})
        this.$dispatch('setMsg', {success: this.translations['Added to swatch box.']})
      } else {
        if (exists) {
          localStorage.removeItem(key)
          this.$dispatch('setSwatch', {key: key, value: ''})
          message = this.translations['Removed from swatch box.']
          this.$dispatch('setMsg', {success: message})
        } else {
          message = this.translations['You have already four fabrics in swatch box.']
          this.$dispatch('setMsg', {error: message})
        }
      }
    }
  },
  created: function () {
    jQuery.getJSON(this.baseurl + '/designer/ajax/getFabricList', { type: 'shirt' }, function (data) {
      this.fabrics = data
      this.setCurrentData(this.personal['fabric'])
    }.bind(this))
    this.box = { 'component': 'fabric', 'title': window.shirtdesigner.translations['Fabric'], 'todo': window.shirtdesigner.translations['Choose from these fabrics.'], 'active': true }
  },
  ready: function () {
    this.$dispatch('runDesignJQuery')
  }
}
</script>


// WEBPACK FOOTER //
// Fabric.vue?c5e8b650